<div cdkTrapFocus>
  <div mat-dialog-title class="" cdkFocusRegionStart>
    Inserisci l'orario
  </div>
  <div mat-dialog-content class="pb-0">
    <div class="flex align-items-center justify-content-center gap-3 text-2xl">
      <div class="flex flex-column align-items-center justify-content-center gap-1">
        <div class="">
          <app-button (click)="onIncrementClick('hours')" icon="keyboard_arrow_up" color="primary"></app-button>
        </div>
        <div class="flex flex-column align-items-center justify-content-center">
          <div class="surface-50 border-round-xl border-1 border-200 font-medium p-2">
            {{hours | number: '2.0'}}
          </div>
          <div *ngIf="data.showLabels" class="text-xs font-light line-height-1">ore</div>
        </div>
        <div class="">
          <app-button (click)="onIncrementClick('hours', -1)" icon="keyboard_arrow_down" color="primary"></app-button>
        </div>
      </div>
      <div class="">
        :
      </div>
      <div class="flex flex-column align-items-center justify-content-center gap-1">
        <div class="">
          <app-button (click)="onIncrementClick('minutes')" icon="expand_less" color="primary"></app-button>
        </div>
        <div class="flex flex-column align-items-center justify-content-center">
          <div class="surface-50 border-round-xl border-1 border-200 font-medium p-2">
            {{minutes | number: '2.0'}}
          </div>
          <div *ngIf="data.showLabels" class="text-xs font-light line-height-1">minuti</div>
        </div>
        <div class="">
          <app-button (click)="onIncrementClick('minutes', -1)" icon="keyboard_arrow_down" color="primary"></app-button>
        </div>
      </div>
      <div *ngIf="data.showSeconds" class="">
        :
      </div>
      <div *ngIf="data.showSeconds" class="flex flex-column align-items-center justify-content-center gap-1">
        <div class="">
        <app-button (click)="onIncrementClick('seconds')" icon="expand_less" color="primary"></app-button>
        </div>
        <div class="flex flex-column align-items-center justify-content-center">
          <div class="surface-50 border-round-xl border-1 border-200 font-medium p-2">
            {{seconds | number: '2.0'}}
          </div>
          <div *ngIf="data.showLabels" class="text-xs font-light line-height-1">secondi</div>
        </div>
        <div class="">
          <app-button (click)="onIncrementClick('seconds', -1)" icon="keyboard_arrow_down" color="primary"></app-button>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <app-button cdkFocusInitial cdkFocusRegionEnd [mat-dialog-close]="{ hours, minutes, seconds }" label="OK" color="primary" [fullWidth]="false"></app-button>
  </div>
</div>
